export const TASK_COL_WIDTH = 300;
